import type React from 'react';
import styled from 'styled-components';
import Row from 'app/shared/core/Row';
import Container from 'app/shared/core/Container';
import { StreetViewErrorContainer } from './StreetViewError.styles';

const StyledBoldDiv = styled.div`
  font-weight: 700;
`;

const StreetViewError: React.FC = () => {
  return (
    <StreetViewErrorContainer>
      <Container>
        <Row size="md">
          <StyledBoldDiv>Uh oh.</StyledBoldDiv>
          Sorry, street view is not available on this property. Nothing to see here.
        </Row>
      </Container>
    </StreetViewErrorContainer>
  );
};

export default StreetViewError;
